module.exports = {"id":"dp4_4l1q2","text":"Environmental Impacts of Digital Technologies","instructions":"Some digital infrastructures consume large amounts of energy during operation.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.4","questionType":"PickOne","random":false,"options":[{"id":"dp4_4l1q2-a1","text":"True","score":1.8},{"id":"dp4_4l1q2-a2","text":"Not sure","score":0},{"id":"dp4_4l1q2-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.4/l1q2.json
// module id = 1268
// module chunks = 41